import { Button, Grid, Typography, Box, styled } from "@mui/material";
import { Link } from "react-router-dom";
import { generateUniqueId } from "../utils";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";

export const Buttons = (props) => {
  const { t } = useTranslation();
  return (
    <Grid
      container
      spacing={2}
      justifyContent="center"
      sx={{
        mt: `${props.marginTop == undefined ? 10 : props.marginTop}px`,
        mb: `${props.marginBottom == undefined ? 1 : props.marginBottom}px`,
      }}
    >
      {props.onClickConfirm != undefined && props.onClickConfirm != null ? (
        <Grid
          item
          xs={12}
          sm={8}
          sx={{
            marginTop: "2px",
            paddingTop: "2px !important",
            zIndex: props?.zIndex ?? 100,
          }}
        >
          <Button
            id={`btnConfirm_${generateUniqueId()}`}
            fullWidth
            variant="contained"
            sx={{ height: 45, px: 5 }}
            onClick={props.onClickConfirm}
            disabled={props.disabledConfirm}
          >
            {props.ConfirmButtonText == undefined
              ? t("general_continue")
              : props.ConfirmButtonText}
          </Button>
        </Grid>
      ) : null}
      {props.onClickCancel != undefined && props.onClickCancel != null ? (
        <Grid
          item
          xs={12}
          sm={8}
          sx={{
            marginTop: "2px",
            paddingTop: "2px !important",
            zIndex: props?.zIndex ?? 100,
          }}
        >
          <Button
            id={`btnCacel_${generateUniqueId()}`}
            fullWidth
            variant="outlined"
            sx={{ height: 45, px: 10 }}
            onClick={props.onClickCancel}
            disabled={props.disabledCancel}
          >
            {props.CancelButtonText == undefined
              ? "Cancelar"
              : props.CancelButtonText}
          </Button>
        </Grid>
      ) : null}
    </Grid>
  );
};

export const LinkButton = (props) => {
  return (
    <Box
      sx={{
        p: 1,
        textAlign: props.textAlign == undefined ? "right" : props.textAlign,
        width: "90%",
        zIndex: 100,
        mb: `${props.marginBottom == undefined ? 1 : props.marginBottom}px`,
      }}
    >
      <Link
        id={`btnLink_${generateUniqueId()}`}
        style={{ textDecoration: "none" }}
        to={props.LinkButtonUrl}
      >
        <Typography
          variant="body2"
          color="primary"
          sx={{ width: "100%", textAlign: "center" }}
        >
          {props.LinkButtonText}
        </Typography>
      </Link>
    </Box>
  );
};

export const ButtonsLined = (props) => {
  return (
    <Grid
      container
      spacing={2}
      justifyContent="center"
      sx={{
        ...props.sx,
        mt: `${props.marginTop == undefined ? 10 : props.marginTop}px`,
        mb: `${props.marginBottom == undefined ? 1 : props.marginBottom}px`,
      }}
    >
      {props.onClickConfirm != undefined && props.onClickConfirm != null ? (
        <Grid item xs={6} sm={6} sx={{ zIndex: 100 }}>
          <Button
            id={`btnConfirmLined_${generateUniqueId()}`}
            fullWidth
            variant="contained"
            sx={{ height: 35, px: 5 }}
            onClick={props.onClickConfirm}
            disabled={props.disabledConfirm}
          >
            {props.ConfirmButtonText == undefined
              ? "Continuar"
              : props.ConfirmButtonText}
          </Button>
        </Grid>
      ) : null}
      {props.onClickCancel != undefined && props.onClickCancel != null ? (
        <Grid item xs={6} sm={6} sx={{ zIndex: 100 }}>
          <Button
            id={`btnCancelLined_${generateUniqueId()}`}
            fullWidth
            variant="outlined"
            sx={{ height: 35, px: 5 }}
            onClick={props.onClickCancel}
            disabled={props.disabledCancel}
          >
            {props.CancelButtonText == undefined
              ? "Cancelar"
              : props.CancelButtonText}
          </Button>
        </Grid>
      ) : null}
    </Grid>
  );
};

export const ButtonsLinedCustom = (props) => {
  const grid = props.customControl ? 4 : 6;
  return (
    <Grid
      container
      spacing={2}
      justifyContent="center"
      sx={{ ...props.sx, py: 2 }}
    >
      {props.onClickConfirm != undefined && props.onClickConfirm != null ? (
        <Grid item xs={grid} sm={grid} sx={{ zIndex: 100 }}>
          <Button
            id={`btnConfirmCustomLined_${generateUniqueId()}`}
            fullWidth
            variant="contained"
            sx={{ height: 35, px: 5 }}
            onClick={props.onClickConfirm}
            disabled={props.disabledConfirm}
          >
            {props.ConfirmButtonText == undefined
              ? "Continuar"
              : props.ConfirmButtonText}
          </Button>
        </Grid>
      ) : null}
      {props.onClickCancel != undefined && props.onClickCancel != null ? (
        <Grid item xs={grid} sm={grid} sx={{ zIndex: 100 }}>
          <Button
            id={`btnCancelCustomLined_${generateUniqueId()}`}
            fullWidth
            variant="outlined"
            sx={{ height: 35, px: 5 }}
            onClick={props.onClickCancel}
            disabled={props.disabledCancel}
          >
            {props.CancelButtonText == undefined
              ? "Cancelar"
              : props.CancelButtonText}
          </Button>
        </Grid>
      ) : null}
      {props.customControl && (
        <Grid item xs={grid} sm={grid} sx={{ zIndex: 100 }}>
          {props.customControl}
        </Grid>
      )}
    </Grid>
  );
};

export const DynamicButtons = (props) => {
  const { t } = useTranslation();
  const {
    buttons = [],
    marginTop = 10,
    marginBottom = 1,
    zIndex = 100,
  } = props;

  return (
    <Grid
      container
      spacing={2}
      justifyContent="center"
      sx={{ mt: `${marginTop}px`, mb: `${marginBottom}px` }}
    >
      {buttons.map((btn, index) =>
        btn.onClick ? (
          <Grid
            item
            xs={12}
            sm={8}
            key={uuidv4()}
            sx={{ marginTop: "2px", paddingTop: "2px !important", zIndex }}
          >
            <Button
              id={`btn_${btn.id || index}`}
              fullWidth
              variant={btn.variant || "contained"} // "contained" o "outlined"
              sx={{ height: 45, px: btn.paddingX || 5 }}
              onClick={btn.onClick}
              disabled={btn.disabled}
              color={btn.color || "primary"}
            >
              {btn.text}
            </Button>
          </Grid>
        ) : null
      )}
    </Grid>
  );
};

export const GenericButtonList = styled(Box)(({ theme }) => ({
  width: "100% !important",
  padding: "16px",
  gap: "16px",
  minHeight: "56px",
  background: theme.palette.primary.lightContrast,
  border: `1px solid ${theme.palette.primary.contrastText}`,
  borderRadius: "8px",
  marginTop: "16px",
  "&:focus": {
    outline: "none !important",
    background: theme.palette.primary.main80,
    border: `1px solid ${theme.palette.primary.main80}`,
  },
  "&:hover": {
    outline: "none !important",
    background: theme.palette.primary.main60,
    border: `1px solid ${theme.palette.primary.main60}`,
  },
}));
